/**
 * The adoption review's NEW FORM proposals (2026-09-20).
 *
 * A dictionary that names forms the project does not have proposes them
 * rather than rejecting their rows — which is what lets the next study in a
 * programme start from the last one's dictionary. Each proposed form is a
 * ticked item the reader can untick, like the reorders and repeating blocks
 * beside it.
 *
 * THE EMPTY LIST IS NOT THE ABSENT LIST. The server creates nothing when the
 * list is absent, because that means the page predates this feature. So the
 * page always sends one, even with nothing ticked.
 *
 * Pure and DOM-free: `web` has no test runner and must not gain one.
 */

/** Mirrors AdoptNewForm in functions/src/dataDictionary/adoptDictionary.ts. */
export interface NewFormProposal {
  formCode: string;
  formName: string;
  questionCount: number;
  rowNumbers: number[];
}

/** Every proposal starts ticked. */
export function initialNewFormTicks(list: NewFormProposal[] | undefined): Record<string, boolean> {
  const out: Record<string, boolean> = {};
  for (const f of list ?? []) out[f.formCode] = true;
  return out;
}

/**
 * The form codes to send. ALWAYS a list — an empty one when nothing is
 * ticked — and never a code the plan does not propose.
 */
export function tickedNewForms(
  list: NewFormProposal[] | undefined,
  ticks: Record<string, boolean>,
): string[] {
  return (list ?? []).map((f) => f.formCode).filter((code) => ticks[code]);
}

/** "Adverse Events (AE) - create with 2 questions". */
export function newFormLine(f: NewFormProposal): string {
  const name = f.formName && f.formName.trim() ? f.formName.trim() : f.formCode;
  const n = f.questionCount;
  return `${name} (${f.formCode}) - create with ${n} question${n === 1 ? '' : 's'}`;
}
